import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

const CallToAction = () => {
  return (
    <section className="py-20 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-display text-4xl md:text-5xl font-bold mb-4">
          Ready for Your Island Getaway?
        </h2>
        <p className="text-xl md:text-2xl opacity-90 mb-8 max-w-2xl mx-auto">
          Your next favorite family memory is just a booking away.
        </p>
        
        <Button
          asChild
          size="lg"
          className="bg-accent hover:bg-accent/90 text-accent-foreground text-lg px-8 py-6 mb-8"
        >
          <Link to="/book-now">Book Now</Link>
        </Button>
        
        <div className="flex items-center justify-center gap-2 text-lg opacity-90">
          <Phone className="h-5 w-5" />
          <span>Questions? Call us:</span>
          <a 
            href="tel:877-577-7667" 
            className="font-semibold hover:underline"
          >
            877-577-7667
          </a>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
